import { Link } from "react-router-dom";
import { legalFor } from "../lib/legal";
import { openConsentPrefs } from "../lib/consent";

export const LegalLinks = ({ lang }) => {
  const u = legalFor(lang).ui;
  return (
    <nav className="pointer-events-auto absolute bottom-1 left-1/2 z-10 flex -translate-x-1/2 gap-2 whitespace-nowrap text-[10px] text-slate-500" data-testid="legal-links">
      <Link to="/privacy" className="hover:text-slate-800 hover:underline" data-testid="footer-privacy-link">{u.privacy}</Link>·
      <Link to="/cookie" className="hover:text-slate-800 hover:underline" data-testid="footer-cookie-link">{u.cookie}</Link>·
      <button onClick={openConsentPrefs} className="hover:text-slate-800 hover:underline" data-testid="footer-cookie-prefs-btn">{u.prefs}</button>
    </nav>
  );
};
